import React from 'react';
import {
  Typography,
  Box,
  Grid,
  Chip
} from '@mui/material';
import { PeriodComparison } from './types';

interface DrillDownPeriodComparisonProps {
  comparativo_periodo?: PeriodComparison;
  title?: string;
  showPeriodoPrevious?: boolean;
  showMedia12Meses?: boolean;
  variant?: 'outlined' | 'filled';
  size?: 'small' | 'medium';
  icon?: string;
}

const DrillDownPeriodComparison: React.FC<DrillDownPeriodComparisonProps> = ({
  comparativo_periodo,
  title = "Análise Comparativa",
  showPeriodoPrevious = true,
  showMedia12Meses = true,
  variant = "outlined",
  size = "medium",
  icon = "📈"
}) => {
  // Se não há dados comparativos, não renderiza nada
  if (!comparativo_periodo) {
    return null;
  }

  const { periodo_anterior, media_12_meses } = comparativo_periodo;

  // Validações adicionais para garantir que dados essenciais existam
  const hasValidPeriodoAnterior = periodo_anterior && 
    periodo_anterior.periodo && 
    typeof periodo_anterior.crescimento_percentual === 'number';

  const hasValidMedia12Meses = media_12_meses && 
    typeof media_12_meses.valor_medio === 'number' && 
    typeof media_12_meses.variacao_percentual === 'number';

  // Se não há dados válidos para exibir, não renderiza
  if (!hasValidPeriodoAnterior && !hasValidMedia12Meses) {
    return null;
  }

  return (
    <Grid item xs={12} sx={{ mt: 2 }}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1, fontWeight: 600 }}>
        {icon} {title}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {showPeriodoPrevious && hasValidPeriodoAnterior && (
          <Chip 
            label={`vs Período Anterior: ${periodo_anterior.crescimento_percentual > 0 ? '+' : ''}${periodo_anterior.crescimento_percentual.toFixed(1)}%`}
            color={periodo_anterior.crescimento_percentual >= 0 ? 'success' : 'error'}
            variant={variant}
            size={size}
            title={`Comparação com ${periodo_anterior.periodo}: ${periodo_anterior.crescimento_percentual >= 0 ? 'crescimento' : 'redução'} de ${Math.abs(periodo_anterior.crescimento_percentual).toFixed(1)}%`}
          />
        )}
        {showMedia12Meses && hasValidMedia12Meses && (
          <Chip 
            label={`vs Média 12 meses: ${media_12_meses.variacao_percentual > 0 ? '+' : ''}${media_12_meses.variacao_percentual.toFixed(1)}%`}
            color={media_12_meses.variacao_percentual >= 0 ? 'success' : 'error'}
            variant={variant}
            size={size}
            title={`Comparação com média dos últimos 12 meses: ${media_12_meses.variacao_percentual >= 0 ? 'acima' : 'abaixo'} da média em ${Math.abs(media_12_meses.variacao_percentual).toFixed(1)}%`}
          />
        )}
      </Box>
    </Grid>
  );
};

export default DrillDownPeriodComparison; 